import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ToastService } from 'ng-uikit-pro-standard';
import { DocumentoElectronicoResumenService } from 'src/app/services/documento-electronico-resumen.service';
import { MessageRendererService } from 'src/app/services/message-renderer.service';
import { EstadoDocumentoElectronico } from 'src/app/shared/object/IDocumento_electronico.model';
import { ConsoleService } from 'src/app/shared/services/console.service';
import { DatesService } from 'src/app/shared/services/dates.service';
import { FileDownloadService } from 'src/app/shared/services/file-download.service';
import { FormValidatorsService } from 'src/app/shared/services/form-validators.service';
import { SecurityService } from 'src/app/shared/services/security.service';
import { EmpresasEmitidosDetalleComponent } from './detalle/detalle.component';
import * as _ from 'lodash';

@Component({
  selector: 'app-empresas-emitidos',
  templateUrl: './empresas-emitidos.component.html',
  styleUrls: ['./empresas-emitidos.component.scss'],
  providers: [SecurityService]
})
export class EmpresasEmitidosComponent implements OnInit {
  @ViewChild(EmpresasEmitidosDetalleComponent, { static: true }) detalleModal: EmpresasEmitidosDetalleComponent

  // Form
  formHeader: FormGroup;
  initialValues: any

  // Data & Tmp
  rutEmpresa: number
  sucursalCodigo: number
  loading: boolean = false
  listaDocumentos: Array<any> = null
  searchParams: any = null

  optionsMonth: any[] = []
  optionsYear: any[] = []

  // Utils
  private log: any

  constructor(
    private accesolocalstorage: SecurityService,
    private messageRendererService: MessageRendererService,
    private clog: ConsoleService,
    private toastService: ToastService,
    private fb: FormBuilder,
    private formValidatorsService: FormValidatorsService,
    private datesService: DatesService,
    private documentoElectronicoResumenService: DocumentoElectronicoResumenService,
    private fileDownloadService: FileDownloadService
  ) {
    this.log = this.clog.log('EMPRESAS-EMITIDOS')
  }

  ngOnInit() {
    this.rutEmpresa = Number(this.accesolocalstorage.getRutEmpresa())
    this.sucursalCodigo = Number(this.accesolocalstorage.getSucursalCodigo())

    this.loadMesesAndAnhos();
    this.createFormInitialValues()
    this.createForms()
  }

  loadMesesAndAnhos() {
    this.optionsMonth = this.datesService.GetMonths()
    this.optionsYear = this.datesService.GetRangeYears()
  }

  createFormInitialValues() {
    const now = new Date()
    const currentYear = now.getFullYear()
    const currentMonth = now.getMonth() + 1
    this.initialValues = {
      mesPeriodo: currentMonth,
      gestion: currentYear,
    }
  }

  private createForms() {
    this.formHeader = this.fb.group({
      mesPeriodo: [null, [Validators.required]],
      gestion: [null, [Validators.required]],
    });

    this.setInitialValues()
  }

  private setInitialValues() {
    this.formValidatorsService.setInitialState(this.formHeader, this.initialValues)
  }

  buscar() {
    // this.formValidatorsService.validateAllFormFields(this.formHeader)
    // if (!this.formHeader.valid)
    //   return

    this.listaDocumentos = []
    this.loading = true

    const { mesPeriodo, gestion } = this.formHeader.value
    const periodo = new Date(gestion, mesPeriodo - 1, 1)
    const inputParams = {
      empresa_rut: this.rutEmpresa,
      periodo
    }
    this.searchParams = inputParams

    this.log('inputParams', JSON.stringify(inputParams))

    this.documentoElectronicoResumenService.ObtenerEmitidos(inputParams, ({ mensajes, respuesta }) => {
      const ok = respuesta !== null
      if (!ok) {
        this.messageRendererService.showErrors(mensajes)
        return
      }

      this.listaDocumentos = respuesta
      this.loading = false
    })
  }

  loadAndShowDetalle({ tipo_dte_codigo }, estado: EstadoDocumentoElectronico) {
    const { periodo } = this.searchParams
    this.detalleModal.loadAndShow(tipo_dte_codigo, estado, periodo)
  }

  downloadExcel() {
    const inputParams = _.cloneDeep(this.searchParams)
    // delete inputParams.cantidadRegistrosPorPagina
    // delete inputParams.paginaActual

    this.documentoElectronicoResumenService.ObtenerEmitidosExcel(inputParams, ({ mensajes, respuesta }) => {
      const ok = respuesta !== null
      if (!ok) {
        this.messageRendererService.showErrors(mensajes)
        return
      }
      if (respuesta)
        this.fileDownloadService.VerifyAndDownload(respuesta)
    })
  }

}
